import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '../inputs/inputs.module';
import { MonthlySalesSummaryComponent } from 'src/app/components/charts/monthly-sales-summary/monthly-sales-summary.component';
import { OrdersByStatusChartComponent } from 'src/app/components/charts/orders-by-status-chart/orders-by-status-chart.component';
import { ChartOrdersByCategoryComponent } from 'src/app/components/charts/chart-orders-by-category/chart-orders-by-category.component'
import { LoaderComponent } from '../loader/loader.component';
import { CursorComponent } from '../cursor/cursor.component';
import { ScrollTopComponent } from '../scroll-top/scroll-top.component';
import { HeaderComponent } from '../header/header.component';
import { MenuComponent } from '../menu/menu.component';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    LoaderComponent,
    CursorComponent,
    ScrollTopComponent,
    HeaderComponent,
    MenuComponent,
    MonthlySalesSummaryComponent,
    OrdersByStatusChartComponent,
    ChartOrdersByCategoryComponent
  ],
  imports: [
    CommonModule,
    InputsModule,
    MatDialogModule,
    DragDropModule,
    MatTableModule,
    MatIconModule,
    MatDialogModule,
  ],
  exports: [
    LoaderComponent,
    CursorComponent,
    ScrollTopComponent,
    HeaderComponent,
    MenuComponent,
    MatIconModule,
    MatDialogModule,
    MatToolbarModule,
    MatTableModule,
    MatSidenavModule,
    MatListModule,
    MatFormFieldModule,
    MatMenuModule,
    MatButtonModule,
    DragDropModule,
    MatTableModule,
    MatIconModule,
    MatDialogModule,
    MonthlySalesSummaryComponent,
    OrdersByStatusChartComponent,
    ChartOrdersByCategoryComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
